import {
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  inject,
} from '@angular/core'
import { Subject, tap } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

@UntilDestroy()
@Directive({
  selector: '[wmFrontSize]',
  standalone: true,
})
export class SizeDirective implements OnInit, OnDestroy {
  /** Will be triggered on width change */
  @Output() public widthChanged: EventEmitter<number> =
    new EventEmitter<number>()

  /** Will be triggered on height change */
  @Output() public heightChanged: EventEmitter<number> =
    new EventEmitter<number>()

  /** The resize observer */
  private resizeObserver: ResizeObserver

  private _element = inject(ElementRef)

  public ngOnInit(): void {
    this.handleSizeChanges()
  }

  public ngOnDestroy(): void {
    this.resizeObserver.disconnect()
  }

  /**
   * Will know what to do with the resize observer
   * @private
   */
  private handleSizeChanges(): void {
    const elementWidth$: Subject<number> = new Subject()
    const elementHeight$: Subject<number> = new Subject()
    const minTimeToTriggerResponsive = 50
    this.resizeObserver = new ResizeObserver((entries) => {
      elementWidth$.next(entries[0].contentRect.width)
      elementHeight$.next(entries[0].contentRect.height)
    })
    this.resizeObserver.observe(this._element?.nativeElement)
    elementWidth$
      .pipe(
        debounceTime(minTimeToTriggerResponsive),
        tap((res) => this.widthChanged.next(res)),
        untilDestroyed(this)
      )
      .subscribe()
    elementHeight$
      .pipe(
        debounceTime(minTimeToTriggerResponsive),
        tap((res) => this.heightChanged.next(res)),
        untilDestroyed(this)
      )
      .subscribe()
  }
}
